module.exports = __webpack_public_path__ + "img/info-item-3.414e4e94.png";